var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9896 18.0117C17.1676 18.9617 15.9926 19.4997 14.7486 19.4997C14.7096 19.4997 14.6706 19.4997 14.6316 19.4987C6.64359 19.2817 0.216585 12.8546 0.00158517 4.86765C-0.0334148 3.57065 0.512594 2.34162 1.49859 1.49362C2.43559 0.686622 3.65559 0.349714 4.84759 0.562714C5.03059 0.595714 5.18759 0.63761 5.32159 0.68161C5.84959 0.85661 6.23359 1.3138 6.32159 1.8718L6.99164 6.12668C7.07564 6.65968 6.86762 7.19981 6.45062 7.53781C6.36662 7.60581 6.2796 7.67068 6.1886 7.73068C5.9566 7.88868 5.86859 8.1577 5.97259 8.3967C6.97459 10.7017 8.79463 12.5217 11.0986 13.5237C11.3386 13.6287 11.6076 13.5387 11.7696 13.3017C11.8166 13.2337 11.8656 13.1668 11.9156 13.1028C12.2516 12.6748 12.8026 12.4686 13.3466 12.5556L17.6786 13.2768C18.2506 13.3728 18.7156 13.7778 18.8646 14.3098C18.8916 14.4068 18.9176 14.5168 18.9396 14.6418C19.1486 15.8428 18.8026 17.0697 17.9896 18.0117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ea296f93da6c56f1fbe5a5d51f4ade14.svg";
export { ForwardRef as ReactComponent };